var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99992 15.8605C14.1692 15.8605 16.5606 15.1974 16.7916 12.5356C16.7916 9.87573 15.1243 10.0468 15.1243 6.78318C15.1243 4.23396 12.708 1.3335 8.99992 1.3335C5.29179 1.3335 2.87553 4.23396 2.87553 6.78318C2.87553 10.0468 1.20825 9.87573 1.20825 12.5356C1.44012 15.2074 3.83154 15.8605 8.99992 15.8605Z",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1896 18.6191C9.93917 20.0076 7.98849 20.0241 6.72607 18.6191",
    stroke: "#5D6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.c0186b3112b89bf61f1e0403107a4b0e.svg";
export { ForwardRef as ReactComponent };